import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-motores',
  templateUrl: './motores.component.html',
  styleUrls: ['./motores.component.css']
})
export class MotoresComponent implements OnInit {

  isSeguros = false;
  constructor(private router:Router) {
    let url = this.router.url;
    console.log("URL: ", url);
    this.isSeguros = url.split('/')[2].includes('seguros');
   }

  ngOnInit() {
  }

}
